<template>
    <div :class="'vue timparty-loader-overlay ' + otherClass">
      <div :class="'loader-container text-center ' + ( external_image ? 'transparent' : '')">


        <img :src="loader_image" alt="Loading" class="loader">
        <br>
        <div v-if="!hide_text">{{ __('Caricamento in corso') }}</div>
      </div>
    </div>
</template>

<script>

    /* eslint-disable */

    //import LoaderImage from '../assets/images/loaderTimLogo.gif';
    import TimPartyMixin from '../mixins/TimPartyMixin';

    export default {
      name: 'LoaderOverlay',
      mixins: [ TimPartyMixin ],
      props: {
        image: {
          type: String,
          required: false,
        },
        show_winner: {
          type: Boolean,
          required: false,
          default: false,
        },
        hideText: {
          type: Boolean,
          required: false,
          default: false,
        },
        otherClass: {
          type: String,
          required: false,
          default: false,
        },
      },
      data: function(){
        return {
         loader_image: '',
         external_image: false,
         hide_text: false,
        };
      },
      mounted: function(){

        if(this.hideText)
          this.hide_text = this.hideText;

        if(this.image && !this.show_winner){
          this.loader_image = this.image;
          this.external_image = true;
          this.hide_text = true;
        }
        else{
          this.loader_image = this.modulePath('js/src/assets/images/loaderTimLogo.gif')
        }

      },

      methods: {

      },
      computed: {

      },
      watch: {}
    }
  </script>


